import React, { useState } from 'react';
import { Link, usePage } from '@inertiajs/react';
import { Alert } from '../../components/Alert';
import { Button } from '../../components/ui/button';
import { useTrans } from '../../hooks/useTrans';
import { copyToClipboard } from '../../lib/clipboard';
import AuthCard from '../../components/layout/auth/AuthCard';

export default function AuthenticatorLink({ qrCode, secret, configurationIsRequired }) {
    const translate = useTrans();
    const { flash } = usePage().props;
    const [copied, setCopied] = useState(false);

    function handleCopy(e) {
        e.preventDefault();
        copyToClipboard(secret.replace(/\s/g, ''));
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
    }

    return (
        <AuthCard
            title={translate('Stap 1: Koppel je authenticator-app')}
            backLink={configurationIsRequired ? null : '/login'}
        >
            {flash && <Alert variant={flash.type}>{flash.description}</Alert>}

            <p>
                {translate('Om je account extra te beveiligen, vragen we je een authenticator-app te koppelen. Je kunt hiervoor bijvoorbeeld Microsoft Authenticator gebruiken:')}
            </p>

            <div className="flex justify-center gap-3 my-4">
                <a href="https://apps.apple.com/app/microsoft-authenticator/id983156458" target="_blank" rel="noopener">
                    <img src="/assets/img/layout/multi-factor/microsoft-authenticator-app-store.svg" alt="Download on App Store" className="h-[40px]" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.azure.authenticator" target="_blank" rel="noopener">
                    <img src="/assets/img/layout/multi-factor/microsoft-authenticator-play-store.svg" alt="Get it on Google Play" className="h-[40px]" />
                </a>
            </div>

            <b>{translate('Stappen om je authenticator-app te koppelen:')}</b>
            <ol className="list-decimal pl-5 my-2">
                <li>{translate('Open de authenticator-app op je telefoon.')}</li>
                <li>{translate('Kies voor QR-code scannen en scan de QR-code hieronder.')}</li>
            </ol>

            <div className="flex justify-center mt-4 mb-1">
                {qrCode ? (
                    <div className="w-[150px] h-[150px]" dangerouslySetInnerHTML={{ __html: qrCode }} />
                ) : (
                    <Alert variant="error">{translate('Er is een fout opgetreden bij het genereren van de QR-code.')}</Alert>
                )}
            </div>

            <i>{translate("Kun je geen QR-code scannen? Voer de volgende code in via 'Handmatige invoer':")}</i>

            <div className="flex items-center gap-2 mt-2 mb-4 rounded-sm bg-[#f0f0f0] p-2">
                <code className="flex-1 font-mono text-xs text-[#003545]">{secret}</code>
                <button
                    onClick={handleCopy}
                    className={`shrink-0 cursor-pointer transition-colors ${copied ? 'text-[#0e8e6a]' : 'text-[#003545] hover:text-[#003545]/70'}`}
                >
                    {copied ? (
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                    ) : (
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M0.8 7.6C0.8 8.263 1.337 8.8 2 8.8H3.2V8H2C1.779 8 1.6 7.821 1.6 7.6V2C1.6 1.779 1.779 1.6 2 1.6H7.6C7.821 1.6 8 1.779 8 2V3.2H4.4C3.737 3.2 3.2 3.737 3.2 4.4V10C3.2 10.663 3.737 11.2 4.4 11.2H10C10.663 11.2 11.2 10.663 11.2 10V4.4C11.2 3.737 10.663 3.2 10 3.2H8.8V2C8.8 1.337 8.263 0.8 7.6 0.8H2C1.337 0.8 0.8 1.337 0.8 2V7.6ZM4 4.4C4 4.179 4.179 4 4.4 4H10C10.221 4 10.4 4.179 10.4 4.4V10C10.4 10.221 10.221 10.4 10 10.4H4.4C4.179 10.4 4 10.221 4 10V4.4Z" fill="currentColor"/>
                        </svg>
                    )}
                </button>
            </div>

            <Button variant="primary" asChild className="w-full">
                <Link href="/tweestapsverificatie/authenticator/configuratie/verifieren">
                    {translate('Verificatiecode invoeren')}
                </Link>
            </Button>
        </AuthCard>
    );
}
